import axios from 'axios';
import store from '@/store'

const initialState = () => ({
  question_reports: null,
  sending_question_report: false
});

const getOptions = async () => ({
  headers:{
    'Authorization': `Bearer ${await store.state.AuthFirebase.auth.currentUser?.getIdToken()}`,
    'Content-Type': 'application/json'
  }
});

export default {
  namespaced: true,
  state: initialState(),
  mutations: {
    RESET_STATE(state){
      Object.assign(state, initialState())
    },
    SET_QUESTION_REPORTS(state, payload) {
      state.question_reports = payload
    },
    ADD_QUESTION_REPORT(state, payload) {
      state.question_reports = [...(state.question_reports || []), payload]
    },
    SET_SENDING_QUESTION_REPORT(state, payload) {
      state.sending_question_report = !!payload
    }
  },
  actions: {
    async getQuestionReports({ commit }, args) {
      const params = {
        exam_id: args.exam_id,
        contacto_id: store.state.Auth.user.userId,
        attributes: [
          'question_report_id', 'question_id', 'text', 'reviewed_at', 'reviewed_comment', 'question_report_state_id'
        ].join(',')
      }

      try {
        const response = await axios.get(
          process.env.VUE_APP_EDUCACIONIT_API_SERVER + 'alumni/questions-reports',
          {
            ...await getOptions(),
            params
          }
        );

        commit('SET_QUESTION_REPORTS', response.data.data)
        return response.data.data;
      } catch (err) {
        commit('SET_QUESTION_REPORTS', [])
        return [];
      }
    },
    async sendQuestionReport({ commit }, args) {
      const params = {
        exam_id: args.exam_id,
        question_id: args.question_id,
        text: args.text
      };

      commit('SET_SENDING_QUESTION_REPORT', true)

      try {
        const response = await axios.post(
          process.env.VUE_APP_EDUCACIONIT_API_SERVER + 'alumni/questions-reports',
          params,
          await getOptions()
        );

        commit('ADD_QUESTION_REPORT', response.data)
        return response.data;
      } finally {
        commit('SET_SENDING_QUESTION_REPORT', false)
      }
    },
  },
  getters: {
    question_reports: (state) => state.question_reports,
    sending_question_report: (state) => state.sending_question_report,
    question_reports_by_question_id: (state) =>
      (state.question_reports || []).reduce((reports, report) => {
        reports[report.question_id] = report
        return reports
      }, {})
  },
};
